/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { useDispatch } from "react-redux";
import { resetFunctionwithlogin } from "../../../components/ResetFunction";
import { useSelector } from "react-redux";
import useAuthentication from "../../../hooks/useAuthentication";
import { FcCheckmark } from "react-icons/fc";
import { HiOutlineUserGroup } from "react-icons/hi";
import { BsPlusLg } from "react-icons/bs";
const Login = () => {
  const details = localStorage.getItem("loginDetails");
  const user = useSelector((state) => state.user).value;

  const { signin, getCurrentUser } = useAuthentication();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    localStorage.setItem("colorschema", "dark");
    localStorage.setItem("layout", "vertical");
    localStorage.setItem("layoutwidth", "fixed");
    localStorage.setItem("layoutpos", "fluid");
    localStorage.setItem("topbartheme", "dark");
    localStorage.setItem("layoutSized", "lg");
    localStorage.setItem("layoutStyling", "default");
    localStorage.setItem("layoutSidebarStyle", "dark");

    // navigate("/admin-dashboard");
    // navigate("/ft-intro");

    const result = await signin(email.trim().toLowerCase(), password);
    setMessage(result);
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  useEffect(() => {
    if (user && user.isVerified) navigate("/ft-intro");
    else if (user && !user.isVerified) {
      setMessage("إفحص البريد الإلكتروني من أجل تفعيل الحساب.");
    }
  }, [user]);

  const [eye, seteye] = useState(true);

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <div>
      <div className=" page-wrapper account-page black ">
        <div className="main-wrapper black h-auto">
          <div className="account-content">
            <Link to="/ft-intro" className="btn btn-primary apply-btn">
              النسخة المجانية FT
            </Link>
            <Link
              to="/mass-systems"
              className="btn btn-primary apply-btn btn-2"
            >
              Mass Systems
            </Link>

            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/mp-user-dashboard">
                  <img src={Applogo} alt="MassPortal" />
                </Link>
              </div>
              {/* /Account Logo */}

              {/* ============================================================================================== */}
              <div className="account-box black border-0 w-100 row">
                <div className="account-wrapper login-black content  col-sm-12 col-md-6 ">
                  <h3 className="account-title text-primary">
                    فين تراك | Finatrack
                  </h3>{" "}
                  <hr className="text-primary"></hr>
                  <p className="account-subtitle">
                    {" "}
                    منصتك الذكية لمراجعة خدمتك المحاسبية
                  </p>
                  {/* Content-section */}
                  <div className="row">
                    <div className="col-sm-12 col-md-8 min-w-">
                      <ul className="text-primary-ol w-100">
                        <h4 className="text-primary">
                          مصمم للمهنيين
                          <span className="text-secondary "> … </span> ومتاح
                          للجميع.
                        </h4>
                        <p className="w-100">
                          فحص كشوف الرواتب، صناديق التقاعد وكافة بياناتك
                          المالية. حمّل ميزانيتك ودع المستشار الذكي يخبرك إن
                          كانت خدمتك المحاسبية تعمل لصالحك. لا حاجة بعد اليوم
                          لمستشارين – الذكاء الاصطناعي بين يديك!"
                        </p>

                        <h4 className="text-primary mt-2 ">Fintrack </h4>
                        <li className="d-flex ">
                          <span className="icon">
                            {" "}
                            <FcCheckmark className="icon" size={20} />{" "}
                          </span>{" "}
                          دع الذكاء الاصطناعي يراجع محاسبتك ورواتبك
                        </li>
                        <li className="d-flex ">
                          <span className="icon">
                            {" "}
                            <FcCheckmark size={20} />{" "}
                          </span>{" "}
                          هل نظام الرواتب عندك صحيح؟ فين تراك يعرف، بلا مستشارين
                        </li>
                        <li className="d-flex ">
                          <span className="icon ">
                            {" "}
                            <FcCheckmark size={20} />{" "}
                          </span>{" "}
                          الذكاء الاصطناعي صار مستشارك المالي الأول
                        </li>
                        <li className="d-flex ">
                          <span className="icon">
                            {" "}
                            <FcCheckmark size={20} />{" "}
                          </span>{" "}
                          رواتبك، محاسبتك، تقاعدك… كلها تحت نظر فين تراك الذكي
                        </li>
                      </ul>
                    </div>
                    <div className="col-sm-12 col-md-4">
                      {/* Account Logo */}
                      <div className="account-logo">
                        <a href="/">
                          <img src={Applogo} alt="Mass Portal" />
                        </a>
                      </div>
                      {/* /Account Logo */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 col-sm-12 col-lg-6 col-xl-4 circle-content ">
                      <div className="border-div p-3">
                        <h4 className="parivacy-large text-center fw-bold">
                          33{" "}
                          <span>
                            {" "}
                            <BsPlusLg size={15} className="text-primary" />
                          </span>{" "}
                        </h4>
                        <h5 className="text-center text-primary-white-bold fw-bold mb-3 mt-3">
                          سنوات من الخبرة{" "}
                        </h5>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12 col-lg-6 col-xl-4 circle-content ">
                      <div className="border-div p-3">
                        <h4 className="parivacy-large text-center fw-bold">
                          1200{" "}
                          <span>
                            {" "}
                            <BsPlusLg size={15} className="text-primary" />
                          </span>{" "}
                        </h4>
                        <h5 className="text-center text-primary-white-bold fw-bold  ">
                          مستخدمين يثقون في حلولنا
                        </h5>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12 col-lg-6 col-xl-4 circle-content ">
                      <div className="border-div p-3">
                        <h4 className="parivacy-large text-center fw-bold">
                          20{" "}
                          <span>
                            {" "}
                            <HiOutlineUserGroup
                              size={25}
                              className="text-primary"
                            />
                          </span>
                        </h4>
                        <h5 className="text-center text-primary-white-bold fw-bold mb-3 mt-3">
                          فريق من الخبراء
                        </h5>
                      </div>
                    </div>
                  </div>
                  {/* /Content-section */}
                </div>

                <div className="account-wrapper info-black  content col-sm-12 col-md-6">
                  <h3 className="account-title text-primary">تسجيل الدخول</h3>

                  <hr className="text-primary" />
                  <p className="account-subtitle">الدخول الى نظام Fintrack </p>

                  {/* Account Form */}
                  <div>
                    <form onSubmit={handleSubmit}>
                      <div className="input-block mb-4">
                        <label className="col-form-label mt-3">
                          البريد الالكتروني
                        </label>

                        <input
                          className={`form-control`}
                          type="text"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                          autoComplete="true"
                          placeholder="user@fintrack.expert"
                        />

                        <span className="text-danger"> </span>
                      </div>
                      <div className="input-block mb-4">
                        <div className="row">
                          <div className="col">
                            <label className="col-form-label mt-3">
                              كلمة المرور
                            </label>
                          </div>
                          <div className="col-auto mt-3">
                            <Link className="text-muted" to="/forgot-password">
                              نسيت كلمة المرور؟
                            </Link>
                          </div>
                        </div>
                        <div style={{ position: "relative" }}>
                          <input
                            className={`form-control `}
                            type={eye ? "password" : "text"}
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            autoComplete="off"
                          />
                          <span
                            style={{
                              position: "absolute",
                              left: "5%",
                              top: "30%",
                            }}
                            onClick={onEyeClick}
                            className={`fa-solid ${
                              eye ? "fa-eye-slash" : "fa-eye"
                            } `}
                          />
                        </div>
                        <span className="text-danger"> </span>
                      </div>
                      <div className="input-block text-center mt-4 pt-4">
                        <button
                          className="btn btn-primary account-btn mt-4"
                          type="submit"
                        >
                          تسجيل الدخول
                        </button>
                      </div>
                    </form>

                    <div className="account-footer ">
                      {message && (
                        <p className="text-danger fs-5 fw-bold">{message}</p>
                      )}
                      <p className="pt-4">
                        ليس لديك حساب?{" "}
                        <Link to="/register" className="text-primary">
                          انشاء حساب جديد
                        </Link>
                      </p>
                    </div>
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
              {/* ================================================================================================= */}
              <div className="account-box border-0 black mt-4 w-100 row about-div ">
                <div className="account-wrapper login-black content col-sm-12 col-md-12">
                  <h2 className=" text-primary">
                    {" "}
                    نظام Fintrack
                    <span className="float-start">
                      <img src={Applogo} width={40} height={40} alt="" />
                    </span>
                  </h2>
                  <hr></hr>
                  <h4 className="pt-3 pb-3">
                    فين تراك… منصتك الذكية لتعرف إذا محاسبك ماشي معك صح
                  </h4>
                  <h4 className="text-primary">ماذا نقدم؟</h4>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      <p> حاسب محاسبك! فين تراك بيراجعلك كلشي بذكاء</p>
                    </li>
                    <li>
                      <p>
                        {" "}
                        صندوق التقاعد؟ كشف الرواتب؟ خليه عـ فين تراك… والذكاء
                        الاصطناعي بيحلها
                      </p>
                    </li>
                    <li>
                      <p>
                        بتدفع لمحاسب ومو متأكد؟ حمّل ورقك وخلي الذكاء الاصطناعي
                        يقولك شو القصة
                      </p>
                    </li>
                    <li>
                      <p>
                        ما في داعي تسأل حدا… فين تراك بيرد عليك وبيعرف كل
                        التفاصيل
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
